import React, { Fragment } from "react";
import { Link, withRouter } from "react-router-dom";

const NavItem = ({
  to,
  icon = false,
  pathName,
  display,
  location,
  subMenuPaths = []
}) => {
  const locationPathName = location.pathname.split("/")[1];
  const isActive = locationPathName === to.split("/")[1];

  return display ? (
    <Fragment>
      <li className="tw-mr-2">
        <Link style={{ textDecoration: "none" }} to={to}>
          <div
            className={`tw-inline-flex tw-p-4 tw-rounded-t-lg tw-border-b-2 tw-mb-1 tw-border-transparent hover:tw-text-gray-200 hover:tw-border-gray-200 ${(isActive ||
              subMenuPaths.includes(`/${locationPathName}`)) &&
              "tw-border-gray-200"}  tw-group`}
          >
            {icon} <p className="tw-ml-2">{pathName}</p>
          </div>
        </Link>
      </li>
    </Fragment>
  ) : (
    <></>
  );
};

export default withRouter(NavItem);
